import _objectWithoutProperties from "/near-peer-app/nearpeer-frontend/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["center", "children"];
import { createElementObject, createPathComponent, extendContext, updateCircle } from '@react-leaflet/core';
import { CircleMarker as LeafletCircleMarker } from 'leaflet';
export var CircleMarker = createPathComponent(function createCircleMarker(_ref, ctx) {
  var center = _ref.center,
    _c = _ref.children,
    options = _objectWithoutProperties(_ref, _excluded);
  var marker = new LeafletCircleMarker(center, options);
  return createElementObject(marker, extendContext(ctx, {
    overlayContainer: marker
  }));
}, updateCircle);